import ".././styles/Footer.css";
import pccmlogo from ".././assets/pccm_logo.png";
import substacklogo from ".././assets/instagram-logo.png";
import facebooklogo from ".././assets/facebook-logo.png";
import { HashLink as Link } from 'react-router-hash-link';

function Footer() {
    return (
        <>
            <div className="footer-wrapper">
                <div className="footer">
                    <div className="footer-labels">
                        <div className="left-side">
                            <Link to="/"><img className="footer-logo" src={pccmlogo} alt=""></img></Link>
                            <div className="text-under-logo">
                                <a href="https://maps.app.goo.gl/Xb2oSrisNXxeNwWD9">
                                    737 Keewatin St, Winnipeg, MB <br></br>R2X 3B9
                                </a>
                            </div>
                        </div>
                        <div className="right-side">
                            <ul className="footer-section">
                                <li className="footer-title">Organization</li>
                                <li><Link to="/aboutus#boardmembers">Board Members</Link></li>
                                <li><Link to="/constitution">Conditions & By-Laws</Link></li>
                                <li><Link to="/report">Finance & Report</Link></li>
                            </ul>
                            <ul className="footer-section">
                                <li className="footer-title">Community</li>
                                <li><Link to="/events#events">Upcoming Events</Link></li>
                                <li><Link to="/events#programs-and-services">Programs & Services</Link></li>
                                <li><Link to="/news">News</Link></li>
                                {/* <li><Link to="/memberships">Memberships</Link></li> */}
                            </ul>
                            <ul className="footer-section">
                                <li className="footer-title">Contact</li>
                                <li>Email: thenewpccm@gmail.com</li>
                                <li>Phone: &#40;204&#41; 775-4928</li>
                                <span className="footer-contacts">
                                    <li><a href="https://www.facebook.com/groups/3555107267913403/"><img src={facebooklogo} className="ig-logo"></img></a></li>
                                    <li><a href="https://thenewpccm.substack.com/"><img src={substacklogo} className="ig-logo"></img></a></li>
                                </span>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-copyright-wrapper">
                <div className="footer-copyright copyright-section">
                    <div className="copyright">
                        v1.3.9 | © 2024-2025 Philippine Canadian Centre of Manitoba. All rights reserved.
                    </div>
                    <div className="privacy-terms">
                        <div className="privacy-policy">
                            Privacy & Policy
                        </div>
                    <div className="terms-conditions">
                            Terms & Conditions
                    </div>
                    </div>
                </div>
            </div>
            <div className="footer-credits">
                <p>2024 Web Designer: Jericho Dinozo</p>
                <p>2025 Web Developer: Royce Arugay</p>
            </div>
        </>
    );
}

export default Footer;